import { Action } from 'redux';

import { PersonalSpaceInfo } from '../../ts/restApi/personalSpace/PersonalSpace';
import { isGetPersonalSpaceSuccededAction } from '../actions/PersonalSpaceActions';

const defaultPersonalSpaceInfo: PersonalSpaceInfo = {
  luid: '',
  ownerLuid: '',
  readOnly: false // this is set false so the personal space warning does not showup and disappear if the ps is not readonly
};

export function personalSpaceReducer(previousState: PersonalSpaceInfo = defaultPersonalSpaceInfo, action: Action): PersonalSpaceInfo {
  if (isGetPersonalSpaceSuccededAction(action)) {
    return ({
      luid: action.personalSpace.luid,
      ownerLuid: action.personalSpace.ownerLuid,
      readOnly: action.personalSpace.readOnly,
    });
  }

  return previousState;
}